import axios from 'axios'

import getHeaders from '../helpers/headers'
import config from '../../constants/endpoints.js'

const { endpoints: { company: { newCategories: URL } } } = config
const RECORDS_URL = `${URL}/records`

const getUrl = (url, categoryId = null) => {
  const _url = url.replace(':categoryId', categoryId ? categoryId : '')
  return _url
}

const get = (brands, delegations, sort) =>
  axios({
    method: 'post',
    url: `${URL}/list`,
    data: {
      brands,
      delegations,
      sort
    },
    headers: getHeaders(true),
  })

const getByOperators = (operators, sort) =>
  axios({
    method: 'post',
    url: `${URL}/list`,
    data: {
      filterByOperator: true,
      operators,
      sort
    },
    headers: getHeaders(true),
  })

const getById = (categoryId) =>
  axios({
    method: 'get',
    url: getUrl(`${URL}/:categoryId`, categoryId),
    headers: getHeaders(true),
  })

const put = (categoryId, category) =>
  axios({
    method: 'put',
    url: getUrl(`${URL}/:categoryId`, categoryId),
    headers: getHeaders(true),
    data: category
  })

const post = (category) =>
  axios({
    method: 'post',
    url: `${URL}/create`,
    headers: getHeaders(true),
    data: category
  })

const remove = (categoryId) =>
  axios({
    method: 'delete',
    url: getUrl(`${URL}/:categoryId`, categoryId),
    headers: getHeaders(true),
  })

const filters = () =>
  axios({
    method: 'get',
    url: `${URL}/filters`,
    headers: getHeaders(true),
  })

const records = {
  add: (userId, type, typeId, categoryId) => axios({
    method: 'post',
    url: `${RECORDS_URL}/add`,
    headers: getHeaders(true),
    data: {
      userId,
      type,
      id: typeId,
      category: categoryId
    }
  }),

  remove: (userId, type, typeId, category) => axios({
    method: 'post',
    url: `${RECORDS_URL}/remove`,
    headers: getHeaders(true),
    data: {
      userId,
      type,
      id: typeId,
      category
    }
  }),

  list: (type, id) => axios({
    method: 'post',
    url: `${RECORDS_URL}/list`,
    data: { id, type },
    headers: getHeaders(true),
  }),

  search: (brands, delegations, name = '') => {
    let data = {
      brands,
      delegations
    }
    if (name) data.name = name
    return axios({
      method: 'post',
      url: `${RECORDS_URL}/search`,
      headers: getHeaders(true),
      data
    })
  },
}

export default {
  get,
  getById,
  getByOperators,
  put,
  post,
  remove,
  filters,
  records
}